import { type FC, type ReactNode } from "react";
import { IconCopy } from "~/components/Iconfont/Iconfont";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "~/Provider/Snackbar";
import clsx from "clsx";
import { hapticFeedback } from "@telegram-apps/sdk-react";
interface CopyProps {
    copyText: string;
    className?: string;
    iconClassName?: string;
    children: ReactNode;
    onCopy?: Function;
    customSlot?: boolean;
    onToastClose?: Function;
    disabled?: boolean;
    copyToastText?: string;
    ifAntdToast?: boolean;
}

export const Copy: FC<CopyProps> = (props) => {
    const {
        iconClassName,
        children,
        customSlot,
        onCopy,
        copyText = "",
        copyToastText = "",
        ifAntdToast = false,
        disabled,
    } = props;
    const { t } = useTranslation();
    const snackbar = useSnackbar();

    const Wrapper = (props) => {
        return disabled ? (
            props.children
        ) : (
            <CopyToClipboard {...props}>{props.children}</CopyToClipboard>
        );
    };

    return (
        <>
            <Wrapper
                text={disabled ? "" : copyText || ""}
                onCopy={() => {
                    onCopy && onCopy(copyText || "");
                    // if (ifAntdToast) {
                    //     antdToast('success', copyToastText || t('copy_success'));
                    // } else {
                    snackbar.success(copyToastText || t("copy_success"));
                    // }
                    hapticFeedback.impactOccurred("light");
                }}
            >
                {customSlot ? (
                    children
                ) : (
                    <div className="inline-flex max-w-full items-center justify-center cursor-pointer break-words whitespace-pre">
                        <div className="flex-1 max-w-full overflow-hidden break-words whitespace-pre-wrap">
                            {children}
                        </div>
                        <IconCopy
                            className={clsx(
                                "text-text_1 text-[18px] ml-[4px]",
                                iconClassName || ""
                            )}
                        />
                    </div>
                )}
            </Wrapper>
        </>
    );
};

// export default Copy
